import {Injectable} from '@angular/core';
import {LocalStorageService} from '@dcp/configurator';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  constructor(private localStorageService: LocalStorageService) { }

  hasPermission(permission: string): boolean {
    const permissionsData = this.localStorageService.getItem('permissionsData');
    return !permissionsData || JSON.parse(permissionsData)?.userGroups?.[0]?.permissions.some(p => p.name === permission);;
  }
}
